import React, { useEffect, useState } from "react";
import { getWallId } from "../../../../utils";
import LoadingScreen from "../../../CommonComponents/LoadingScreen";
import Error from "../Themes/Error";
import { PREVIEW_URL } from "../../../../actions/api";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

const ThemeRender = React.memo(({ params, demoWall, errorCode, error, product, loading, reloadLivePreview, previewProduct, onShowDemoPost }) => {

  const [loadingIframe, setLoadingIframe] = useState(true)
  const wallId = Object.keys(params).length > 0 ? params?.wallID : getWallId();

  useEffect(() => {
    onLoad();
  }, [reloadLivePreview, demoWall, product])

  const onLoad = () => {
    setLoadingIframe(true)
    const editor = true
    window.editor = editor;
    const wallRender = document.getElementById("wallRender")
    wallRender.innerHTML = "";
    wallRender.innerHTML = `<iframe src='${PREVIEW_URL}${wallId}&editor=1&personalize=1&preview=1${product == 1 ? `&embed=true` : ``}' width="100%" height="100%"  onload="${setTimeout(() => setLoadingIframe(false), 2000)}" id="personalizePreview"></iframe>`;
  }

  return <div className="personalize-wall">
    <div className='theme-switch-box'>
      <div className={`theme-switch-btn ${!product ? `active` : ``} `} onClick={() => product ? previewProduct() : null}> <FontAwesomeIcon type={'light'} icon={'display'} iconClass={'fs-5 me-2'} /> Digital Display </div>
      <div className={`theme-switch-btn ${product ? `active` : ``} `} onClick={() => !product ? previewProduct(1) : null}><FontAwesomeIcon type={'light'} icon={'browser'} iconClass={'fs-5 me-2'} /> Website
      </div>
    </div>
    <div id="wallRender"></div>
    {loading && <div style={{ width: '100%', position: 'absolute', zIndex: 103, height: '100%', top: "0px", right: "0px" }}><LoadingScreen /></div>}
    {demoWall == 1 && errorCode ? <Error errorData={error} onShowDemoPost={onShowDemoPost} /> : <></>}
  </div>
})

export default ThemeRender;